import React from "react"
import { Link, useLocation } from "react-router-dom"
import { Chip } from "@mui/material"

const ForbiddenPage = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const message =
    queryParams.get("message") ??
    "Sorry, you don't have permission to view this page."
  const urlDecodedMessage = decodeURIComponent(message)

  return (
    <div className="error-page">
      <h1>403 - Forbidden</h1>
      <Chip
        label={urlDecodedMessage}
        color="success"
        style={{ marginLeft: "10px" }}
      />
      <p>If you believe this is an error, please contact support.</p>
      <Link to="/">Go back to homepage</Link>
    </div>
  )
}

export default ForbiddenPage
